import { useLocalObservable } from 'mobx-react-lite';
import { runInAction } from 'mobx';
import { todayIso } from '@/lib/dateUtils';
import { updateCameraStatus } from '@/models/camera/service';
import type { ServicesData } from './useServicesData';

export function useStatusModal(services: ServicesData) {
  const store = useLocalObservable(() => ({
    isOpen: false,
    idCamera: '',
    cameraName: '',
    currentStatus: '' as 'Активный' | 'Неактивный',
    comments: '',
    isLoading: false,
    error: null as string | null,
  }));

  function open(idCamera: string, cameraName: string, currentStatus: 'Активный' | 'Неактивный') {
    runInAction(() => {
      store.isOpen = true;
      store.idCamera = idCamera;
      store.cameraName = cameraName;
      store.currentStatus = currentStatus;
      store.comments = '';
      store.error = null;
    });
  }

  function close() {
    runInAction(() => {
      store.isOpen = false;
    });
  }

  function setComments(value: string) {
    runInAction(() => {
      store.comments = value;
    });
  }

  function submit() {
    const idCamera = store.idCamera;
    const newRawStatus = store.currentStatus === 'Активный' ? ('0' as const) : ('1' as const);
    runInAction(() => {
      store.isLoading = true;
      store.error = null;
    });
    updateCameraStatus(idCamera, {
      status: store.currentStatus === 'Активный' ? 0 : 1,
      date: todayIso(),
      comments: store.comments || undefined,
    })
      .then(() => {
        runInAction(() => {
          store.isOpen = false;
          store.isLoading = false;
        });
        services.applyLocalStatus(idCamera, newRawStatus);
        services.reload();
      })
      .catch((err: Error) =>
        runInAction(() => {
          store.error = err.message;
          store.isLoading = false;
        })
      );
  }

  return {
    get isOpen() {
      return store.isOpen;
    },
    get idCamera() {
      return store.idCamera;
    },
    get cameraName() {
      return store.cameraName;
    },
    get currentStatus() {
      return store.currentStatus;
    },
    get comments() {
      return store.comments;
    },
    get isLoading() {
      return store.isLoading;
    },
    get error() {
      return store.error;
    },
    open,
    close,
    setComments,
    submit,
  };
}

export type StatusModal = ReturnType<typeof useStatusModal>;
